import { Navigate, Outlet } from 'react-router-dom';

export default function PrivateRoute() {
  const token = localStorage.getItem('airex_cp_token');
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}
